import React from 'react';
import './ContainerPadrao.css';

const ContainerPadrao = ({ 
    children, 
    titulo, 
    subtitulo,
    height,
    width,
    linhaDivisoria = false,
}) => {
    return (  
        <div
            className="container-padrao-wrapper"
            style={
                {
                    ...(height ? { height: `${height}rem` } : {}),
                    ...(width  ? { width:  `${width}rem` }  : {}),
                }
            }
        >
            {titulo && <h2 className="container-padrao-titulo">{titulo}</h2>}
            {linhaDivisoria && <hr className="container-padrao-linha-divisoria" />}
            {subtitulo && <div className="container-padrao-subtitulo">{subtitulo}</div>}
            <div className="container-padrao-conteudo">
                {children}
            </div>
        </div>
    );
}
 
export default ContainerPadrao;